import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var container = /*#__PURE__*/css(media('>=tablet'), "{max-width:415px;}", media('>=desktop'), "{display:flex;flex-wrap:nowrap;align-items:flex-end;justify-content:space-between;}");
export var searchBar = /*#__PURE__*/css("width:100%;", media('>=tablet'), "{padding:0 7px;}", media('>=desktop'), "{padding:0;}");
export var filterContainer = /*#__PURE__*/css("display:flex;margin-top:10px;", media('>=desktop'), "{margin-top:0;margin-left:40px;}");
export var filterSection = {
  name: "apepos",
  styles: "margin:0 8px;"
};